import { lazy as lazyLoad } from 'react';

import type { RouteDefinition } from '../../route';
import { route } from '../job-list/constants';

const lazy = {
    JobCreatePage: lazyLoad(async () => {
        const { JobCreatePage } = await import('./JobCreatePage');

        return { default: JobCreatePage };
    }),
    JobEditPage: lazyLoad(async () => {
        const { JobEditPage } = await import('./JobEditPage');

        return { default: JobEditPage };
    }),
};

export const routes: readonly RouteDefinition[] = [
    {
        documentTitle: 'pages.jobs.title',
        page: lazy.JobCreatePage,
        path: route.patterns.job.create,
    },
    {
        documentTitle: 'pages.jobs.title',
        page: lazy.JobEditPage,
        path: route.patterns.job.edit,
    },
];
